<template>
    <div>
        <!-- 查询 -->
        <div class="searchPanel">
            <SearchForm 
                :class="{queryForm_en:lang == 'en', queryForm_zh:lang == 'zh'}" 
                :form="queryForm"
                @handleInputChange="handleInputChange"
                @handleSelectChange="handleQuerySelectChange"
                @handlePressEnter="handleQueryPressEnter"
            ></SearchForm>
        </div>

        <Table
            :table="table"
            @handleChangePagination="handleChangePagination"
        >
            <!-- 表头自定义按钮 -->
            <template v-slot:operateBtn>
                <a-button type="primary" size="small" class="operate_btn" @click="handle('add')">
                    <component :is="$antIcons['PlusOutlined']"></component>
                    {{$t('firmware.add')}}
                </a-button>
            </template>
            
            <!-- 表格列自定义列内容 -->
            <template v-slot:customCol="{props}">
                <template v-if="props.column.key == 'status'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.status_val == 0 ? 'green' : props.record.status_val == 1 ? 'blue' : 'default' "
                        >{{ props.record.status }}</a-tag>
                    </div>
                </template>
                <template v-if="props.column.key == 'environment'">
                    <div class="editable-cell"> 
                        <a-tag
                            :color="props.record.environment_val == 0 ? 'green' : 'orange'"
                        >{{ props.record.environment }}</a-tag>
                    </div>
                </template>
            </template>

            <!-- 表格操作按钮 -->
            <template v-slot:tableAction="{props}">
                <template v-if="props.column.key === 'action'">
                    <a-button type="link" size="small" :disabled="props.record.status_val == 2" style="margin-right:10px" @click="handle('cancel',props.record)">
                        {{$t('notice.cancel')}}
                    </a-button>
                    <a-button type="link" size="small" :disabled="props.record.status_val == 2" style="margin-right:10px" @click="handle('download',props.record)">
                        {{$t('base.download')}}
                    </a-button>
                </template>
            </template>
        </Table>

        <!-- 上传固件 -->
        <a-modal 
            v-model:visible="visible" 
            title="上传固件" 
            width="700px"
            @cancel="handleCancel"
            @ok="handleOk"
        >
            <a-form layout="vertical" :model="formState" >
                <a-form-item :label="t('firmware.file_desc')" v-bind="validateInfos.firmware_desc">
                    <a-input v-model:value="formState.firmware_desc" :maxlength="1000" />
                </a-form-item>
                <a-form-item v-bind="validateInfos.file">
                    <a-upload
                        class="uploadFirmware"
                        v-model:file-list="fileList"
                        name="file"
                        action=""
                        accept=".bin"
                        maxCount="1"
                        @change="handleChange"
                    >
                        <a-button>
                            <upload-outlined></upload-outlined>上传固件
                        </a-button>
                    </a-upload>
                </a-form-item>
            </a-form>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch } from "vue";
    import Table from "@/components/Table.vue";
    import SearchForm from "@/components/Form.vue";
    import { useRouter } from "vue-router";
    import { QueryForm } from './js/formConfig.js';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
    import { FirmwareApi } from '@/api/FirmwareApi.js';
    import { debounce } from 'lodash-es';
    import { Form } from 'ant-design-vue';

    const { t } = useI18n()
    const router = useRouter()

    const useForm = Form.useForm
    const queryForm = reactive(QueryForm)
    const visible = ref(false)
    const detail = ref(null)
    const table = ref({
        data: [],
        columns: [
            {
                title: '#',
                dataIndex: 'serial',
                key: 'serial',
                width: 70,
                resizable: true,
                fixed: 'left',
            },
            {
                title: t('firmware.customer_name'),//客户编码
                dataIndex: 'customer_name',
                key: 'customer_name',
                width: 100,
                resizable: true,
                locel:'firmware.customer_name',
            },
            {
                title: t('firmware.manufacturer_name'),//车厂编号
                dataIndex: 'manufacturer_name',
                key: 'manufacturer_name',
                width: 100,
                resizable: true,
                locel:'firmware.manufacturer_name',
            },
            {
                title: t('firmware.model_name'),//'车型编码'
                dataIndex: 'model_name',
                key: 'model_name',
                width: 100,
                resizable: true,
                locel:'firmware.model_name',
            },
            {
                title: t('firmware.hardware_platform_name'),//车厂编号
                dataIndex: 'hardware_platform_name',
                key: 'hardware_platform_name',
                width: 130,
                resizable: true,
                locel:'firmware.hardware_platform_name',
            },
            {
                title: t('firmware.hardware_version'),//'硬件版本'
                dataIndex: 'hardware_version',
                key: 'hardware_version',
                width: 100,
                resizable: true,
                locel:'firmware.hardware_version',
            },
            {
                title: t('firmware.software_version'),//'软件版本'
                dataIndex: 'software_version',
                key: 'software_version',
                width: 100,
                resizable: true,
                ellipsis :true,
                locel:'firmware.software_version',
            },
            {
                title: t('firmware.file_desc'),//'固件描述'
                dataIndex: 'file_desc',
                key: 'file_desc',
                width: 520,
                resizable: true,
                locel:'firmware.file_desc',
            },
            {
                title: t('firmware.status'),//'状态'
                dataIndex: 'status',
                key: 'status',
                width: 100,
                resizable: true,
                locel:'firmware.status',
            },
            {
                title: t('firmware.environment'),//'环境'
                dataIndex: 'environment',
                key: 'environment',
                width: 120,
                resizable: true,
                locel:'firmware.environment',
            },
            {
                title: t('firmware.customer_code'),//'车厂编码'
                dataIndex: 'customer_code',
                key: 'customer_code',
                width: 100,
                resizable: true,
                locel:'firmware.customer_code',
            },
            {
                title: t('firmware.manufacturer_code'),//'车厂编码'
                dataIndex: 'manufacturer_code',
                key: 'manufacturer_code',
                width: 100,
                resizable: true,
                locel:'firmware.manufacturer_code',
            },
            {
                title: t('firmware.model_code'),//'车型编码'
                dataIndex: 'model_code',
                key: 'model_code',
                width: 100,
                resizable: true,
                locel:'firmware.model_code',
            },
            {
                title: t('firmware.hardware_platform_code'),//'硬件平台编码'
                dataIndex: 'hardware_platform_code',
                key: 'hardware_platform_code',
                width: 120,
                resizable: true,
                locel:'firmware.hardware_platform_code',
            },
            {
                title: t('firmware.software_main_version'),//'主版本'
                dataIndex: 'software_main_version',
                key: 'software_main_version',
                width: 110,
                resizable: true,
                locel:'firmware.software_main_version',
            },
            {
                title: t('firmware.software_item_version'),//'次版本'
                dataIndex: 'software_item_version',
                key: 'software_item_version',
                width: 110,
                resizable: true,
                locel:'firmware.software_item_version',
            },
            {
                title: t('firmware.crc_val'),//'CRC原始值'
                dataIndex: 'crc_val',
                key: 'crc_val',
                width: 120,
                resizable: true,
                locel:'firmware.crc_val',
            },
            {
                title: t('firmware.create_time'),//'创建日期'
                dataIndex: 'create_time',
                key: 'create_time',
                width: 120,
                resizable: true,
                locel:'firmware.create_time',
            },
            {
                title: t('base.operate'),//'操作'
                key: 'action',
                fixed: 'right',
                width: 160,
                resizable: true,
            },
        ],
        configs: {
            table: {
                pagination: {
                    total: 0,
                },
                rowClassName:(record, index) => (index % 2 === 1 ? 'table-striped' : null)
            },
            scroll: {
                x: 1500,
                y: 550,//设置表格高度，固定表头
            },
            rowSelection: false,
            loading: true,
            pagination: {
                hideOnSinglePage: false,
                position: ['bottomLeft'],
                responsive: true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current: 1,
                pageSize: 10,
                pageSizeOptions: ['10', '20', '50'],
                total: 0,
                showTotal: () => t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn: {
                showSearch: false,
                showAdd: false,
            }
        },
    })

    const formState = reactive({
        firmware_desc:'',
        file:null,
    })
    const rulesRef = reactive({
        firmware_desc: [
            {
                required: true,
                message: '固件描述不能为空！',
            },
        ],
        file: [
            {
                required: true,
                message: '请上传固件！',
            },
        ]
    })
    const fileList = ref([])

    const handleInputChange = debounce((val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }, 1000)

    const handleQueryPressEnter = (val, key)=>{
        // console.log(val,'vvv')
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    const handleQuerySelectChange = (val, key)=>{
        table.value.configs.pagination.current = 1
        queryForm.formData[key] = val
        getList()
    }

    // 分页
    function handleChangePagination(config, data) {
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    const handle = (type, row)=>{
        switch(type){
            case 'add':
                visible.value = true
                fileList.value = []
                resetFields()
                break;
            case 'cancel': // 取消固件
                Modal.confirm({
                    title: '提示',
                    icon: createVNode(ExclamationCircleOutlined),
                    content:'是否确认取消固件?',
                    okText: t('base.yes'),
                    cancelText: t('base.no'),
                    onOk() {
                        cancelFirmware(row)
                    },
                });
                break;
            case 'download': // 下载固件
                row.disabled = true
                message.success(t('base.downlaoding'))
                table.value.configs.loading = true
                let token = localStorage.getItem('hd_ota_token')
                let url = `${row.download_path}?Authorization=Bearer ${token}`
                let a = document.createElement('a')
                a.href = url
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                setTimeout(()=>{
                    row.disabled = false
                    table.value.configs.loading = false
                },1500)
                break;
        }
    }

    // 获取固件列表
    const getList = async () => {
        let param = {
            ...queryForm.formData
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize

        table.value.configs.loading = true
        let res = await FirmwareApi.getInstance().getFirmwareList(param, page_num, page_size)
        if (res.code == 0) {
            let data = res.data
            data.records.forEach((i, index) => {
                i.serial = index + 1
                i.status_val = i.status == undefined? '-' : i.status
                i.status = i.status == 0? t('firmware.release') : i.status == 1? t('firmware.test') : t('firmware.cancel')
                i.environment_val = i.environment == undefined? '-' : i.environment
                i.environment = i.environment == 0? t('firmware.product') : t('firmware.test') 
                i.create_time = i.create_time == undefined? '-' : i.create_time
                i.cancel_time = i.cancel_time == undefined? '-' : i.cancel_time
                i.customer_name = !i.customer_name? '-' : i.customer_name
                i.manufacturer_name = !i.manufacturer_name? '-' : i.manufacturer_name
                i.model_name = !i.model_name? '-' : i.model_name
                i.hardware_platform_name = !i.hardware_platform_name? '-' : i.hardware_platform_name
                i.customer_code = !i.customer_code? '-' : i.customer_code
            })
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            table.value.configs.loading = false
        } else {
            message.error(res.msg);
        }
    }

    // 上传固件回调
    const handleChange = (val)=>{
        formState.file = val.file.originFileObj
    }

    // 新增固件
    const { resetFields, validate, validateInfos } = useForm(formState, rulesRef, {});
    const handleOk = async (row)=>{
        validate().then(async () => {
            let formData = new FormData()
            formData.append('file', formState.file)

            let res = await FirmwareApi.getInstance().addFirmware(formData, formState.firmware_desc)
            if (res.code == 0) {
                message.success('固件上传成功！')
                visible.value = false
                table.value.configs.pagination.current = 1
                getList()
            } else {
                message.error(res.msg);
            }
        }).catch(err => {
            console.log('error', err);
        })
    }
    const handleCancel = ()=>{
        resetFields()
    }

    //  取消固件
    const cancelFirmware = async (row)=>{
        let param = {
            id: row.id,
        }
        let res = await FirmwareApi.getInstance().cancelFirmware(param, row.id)
        if (res.code == 0) {
            table.value.configs.pagination.current = 1
            getList()
        } else {
            message.error(res.msg);
        }
    }

    onMounted(()=>{
        getList()
    })

</script>

<style lang="scss" scoped>
.searchPanel{
    margin-bottom: 5px;
    background: #fff;
    border-bottom: 1px dashed #ddd;

    ::v-deep .ant-form-item{
        margin-bottom: 4px;
    }
}

.detail_item{
    padding: 10px 0;
    .label{
        font-size:14px;
        font-weight: 600;
    }

    .value{
        color: #666;
    }
}

.uploadFirmware{
    ::v-deep .anticon-delete{
        display: none;
    }

    ::v-deep .ant-upload-list-item-name,
    ::v-deep .anticon-paper-clip{
        color: #1890ff;
    }

    ::v-deep .ant-upload-list-item-name{
        overflow: visible;
    }
}

::v-deep .ant-table tfoot>tr>td, 
::v-deep .ant-table tfoot>tr>th, 
::v-deep .ant-table-tbody>tr>td, 
::v-deep .ant-table-thead>tr>th {
    overflow-wrap: break-word;
    padding: 14px;
    position: relative;
}
</style>